import { useState, useRef, useEffect } from 'react'

import ensureMTCaptcha from 'Utils/ensureMTCaptcha'

function useUserMenu(isCurrentUser, onWidgetLoad) {
  const [activeDropdown, setActiveDropdown] = useState(null)
  const stateRef = useRef(activeDropdown)
  const wrapperRef = useRef(null)
  const isCurrentUserRef = useRef(isCurrentUser)
  const onWidgetLoadRef = useRef(onWidgetLoad)

  useEffect(() => {
    document.addEventListener('click', handleAuthControl, true)
    document.addEventListener('mousedown', handleClickOutside)

    /* eslint-disable-next-line no-undef */
    App.events.subscribe('app:login:open', openLoginDropdown)
    /* eslint-disable-next-line no-undef */
    App.events.subscribe('app:register:open', handleGuestRegister)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)

      document.removeEventListener('click', handleAuthControl)

      /* eslint-disable-next-line no-undef */
      const unsub = App.events.unsubscribe || App.events.remove
      unsub.call(App.events, 'app:login:open', openLoginDropdown)
      unsub.call(App.events, 'app:register:open', handleGuestRegister)
    }
  }, [])

  useEffect(() => {
    isCurrentUserRef.current = isCurrentUser
  }, [isCurrentUser])

  useEffect(() => {
    onWidgetLoadRef.current = onWidgetLoad
  }, [onWidgetLoad])

  function handleAuthControl(e) {
    const closest = e.target.closest('.js-auth-control')
    const container = e.target.classList.contains('js-auth-control') ? e.target : closest

    if (container && !isCurrentUserRef.current) {
      e.stopPropagation()
      e.preventDefault()
      openLoginDropdown()
      ensureMTCaptcha()

      return false
    }
  }

  function openLoginDropdown() {
    if (!isCurrentUserRef.current && onWidgetLoadRef.current) {
      // Trigger widget load before opening dropdown
      onWidgetLoadRef.current('login', () => {
        updateState('login')
      })
    } else if (!isCurrentUserRef.current) {
      updateState('login')
    }
  }

  function handleGuestRegister() {
    if (!isCurrentUserRef.current && onWidgetLoadRef.current) {
      // Trigger widget load before opening dropdown
      onWidgetLoadRef.current('register', () => {
        updateState('register')
      })
    } else {
      updateState('register')
    }
  }

  function handleClickOutside(e) {
    const currentRef = wrapperRef.current

    if (currentRef && !currentRef.contains(e.target) && stateRef.current) {
      e.preventDefault()

      return updateState(null)
    }
  }

  function updateState(val) {
    stateRef.current = val
    setActiveDropdown(val)
  }

  return {
    activeDropdown, setActiveDropdown: updateState, wrapperRef,
  }
}

export { useUserMenu }
